import React, { Component } from 'react';
import { Row, Form, Input, Col, Button } from 'antd';
import { updateOraganization, getOraganizationDetails } from '../../api/OraganizationApis';
import LocationAutocomplete from "../../Components/Autocomplete";

class OraganizationUpdate extends Component {
  state = {
    loading: false,
    action: 'view',
    oraganizationDetails: {},
    selectedAddress: "",
    latLang:{}
  };

  componentDidMount() {
    const orgId = this.props.orgId;
    this.getOraganizationDetails(orgId);
  }

  getOraganizationDetails(orgId) {
    getOraganizationDetails(orgId)
      .then(result => {
        if (result.success) {
          this.setState({
            oraganizationDetails: result.data,
            latLang: "latLang" in result.data ? result.data["latLang"] : {}
          });
        } else {
          console.log(result.errors);
        }
      });
  }

  handleOnChange = event => {
    this.setState({
      praganizationDetails: {
        ...this.state.oraganizationDetails,
        [event.target.id]: event.target.value,
      },
    });
  };

  updateOraganization = e => {
    this.props.form.validateFields(['orgName','address', "email", "phone"],(err, values) => {
      console.log(values)
      if (!err) {
        this.setState({
          loading:true
        })

        const data = {
          entityData: {
            orgName: values["orgName"],
            address: values["address"],
            phone: values["phone"],
            email: values["email"],
            latLang: this.state.latLang
          },
        };
        const orgId = this.props.orgId;
        updateOraganization(orgId, data)
          .then(result => {
            if (result.success) {
              this.setState({ action: 'view' });
              this.getOraganizationDetails(orgId);
            } else {
              console.log(result.errors);
            }
          });
      }
    })
  };

  openEditMode = async() => {
    await this.setState({ action: 'edit',selectedAddress: this.state.oraganizationDetails.address});
    this.props.form.setFieldsValue({
      "orgName": this.state.oraganizationDetails.orgName,
      "address": this.state.oraganizationDetails.address,
      "email": this.state.oraganizationDetails.email,
      "phone": this.state.oraganizationDetails.phone ? this.state.oraganizationDetails.phone : ""
    })
  }

  getAddress= (address,latLng,id) => {
    this.props.form.setFieldsValue({
      [id]: address,
    });
    this.setState({
      latLang: latLng
    })
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>{
        this.state.action === 'view' ?
          <Row>
            <Col md={15}>
            <Form className='form-border' onSubmit={this.addOraganization}>
              <Row className='add-lead-button-margin' style={{ marginTop: '20px' }}>
                <Col span={17} />
                <Col span={3} className='add-lead-save'>
                  <Button type="primary" onClick={() => { this.openEditMode() }}>Edit</Button>
                </Col>
              </Row>
              <Row>
                <table style={{width:"100%",margin:"20px"}}>
                  <tbody>
                    <tr>
                      <th style={{padding:"20px"}}>Oraganization Name</th>
                      <td style={{padding:"20px"}}>{this.state.oraganizationDetails.orgName}</td>
                    </tr>
                    <tr>
                      <th style={{padding:"20px"}}>Address</th>
                      <td style={{padding:"20px"}}>{this.state.oraganizationDetails.address}</td>
                    </tr>
                    <tr>
                      <th style={{padding:"20px"}}>Email</th>
                      <td style={{padding:"20px"}}>{this.state.oraganizationDetails.email}</td>
                    </tr>
                    <tr>
                      <th style={{padding:"20px"}}>Phone</th>
                      <td style={{padding:"20px"}}>{this.state.oraganizationDetails.phone}</td>
                    </tr>
                  </tbody>
                </table>                
                </Row>
                </Form>
                </Col>
          </Row>
          :
          <Row>
            <Form className='form-border'>
              <Row className='add-lead-button-margin' style={{ marginTop: '20px' }}>
                <Col span={13} />
                <Col span={2} offset={1} className='add-lead-cancel'>
                  <Button onClick={() => { this.setState({ action: 'view' }); }}>Cancel</Button>
                </Col>
                <Col span={3} className='add-lead-save'>
                  <Button type="primary" onClick={() => this.updateOraganization()}>Update</Button>
                </Col>
              </Row>
              <Row gutter={8} style={{padding:"20px"}}>
                <Col lg={15} md={15} sm={24} xs={24}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#0E4D90' }}>Org Name</span>} >
                    {getFieldDecorator('orgName', {
                      rules: [{ required: true, message: 'Please input your Org Name' }],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col lg={15} md={15} sm={24} xs={24}>
                  <Form.Item className="Formitem"
                    label={<span className="label">Address</span>}>
                    {getFieldDecorator('address', {
                      rules: [{ required: true, message: 'Please input your Address!' }],
                    })(<LocationAutocomplete getAddress={(address,latLng) => this.getAddress(address,latLng, 'address')} editMode={true} address={this.state.selectedAddress} setAddress={(address) => {this.setState({selectedAddress: address})}} />)}
                  </Form.Item>
                </Col>
                <Col lg={15} md={15} sm={24} xs={24}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#0E4D90' }}>Phone</span>} >
                    {getFieldDecorator('phone', {
                      rules: [{ required: true, message: 'Please input phone number' }],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col lg={15} md={15} sm={24} xs={24}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#0E4D90' }}>Email</span>} >
                    {getFieldDecorator('email', {
                      rules: [{ required: true, message: 'Please input email' }],
                    })(<Input />)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
      }
      </>
    );
  }
}
export default Form.create({ name: 'OraganizationUpdate' })(OraganizationUpdate);
